import { Accreditation } from "constants/draftingAttributes";

/**
 * Derive vendor-bred status for a sale lot.
 *
 * A `vendorBredOverride` on draftingAttributes takes precedence — only
 * `Accreditation.ALL` maps to true; any other value (including NONE or the
 * unused SOME) maps to false. Without an override, fall back to the
 * consignment declaration's `owned_since_birth` flag.
 */
export const getIsSaleLotVendorBred = (
  saleLot: SaleLot | null | undefined,
  consignment: Consignment | null | undefined,
): boolean | null => {
  if (!saleLot) {
    return null;
  }
  const vendorBredOverride = saleLot.draftingAttributes?.vendorBredOverride;
  if (vendorBredOverride) {
    return vendorBredOverride === Accreditation.ALL;
  }
  return consignment?.declaration?.owned_since_birth ?? null;
};
